<div class="db-page-loading-bar">
  <db-loading-bar [loading]="loading" [progressPercent]="100" [simulation]="loading" [state]="'global'" [height]="3"></db-loading-bar>
</div>
